import { api } from './backend'; 

export const findAll =()=> api.get('/front/print-practice'); 